export default "__VITE_ASSET__b652ef26__"